export default function Count(options){
    let container = options.container
    let stations = options.station
    let container_element, number_element
    this.generate = () =>{
        generateContainer()
        generateNumberElement()
        $(container).html(container_element)
    }

    this.update = (count) =>{
        count = count || stations.filter(x=>x.listItem.isSelected()).length
        number_element.innerHTML = generateText(count)
        $(container_element).toggleClass('show', count > 0)
    }

    function generateContainer(){
        container_element = document.createElement('div')
        container_element.classList.add('offcanvas-stations-count-container')
    }

    function generateNumberElement(){
        number_element = document.createElement('div')
        number_element.classList.add('offcanvas-stations-count-number')
        number_element.innerHTML = generateText(0)
        container_element.appendChild(number_element)
    }

    function generateText(count){
        return "<span class='count'>"+count+"</span><span class='text'> postos selecionados</span>"
    }
}